export const LOGIN = "LOGIN"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILED = "LOGIN_FAILED"

export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS"
export const REFERSH_TOKEN_FAILED = "REFRESH_TOKEN_FAILED"

export const FEATURES = "FEATURES";
export const FEATURES_SUCCESS = "FEATURES_SUCCESS";
export const FEATURES_FAILED = "FEATURES_FAILED";

export const MODULES = "MODULES";
export const MODULES_SUCCESS = "MODULES_SUCCESS";
export const MODULES_FAILED = "MODULES_FAILED";

export const PERMISSIONS = "PERMISSIONS";
export const PERMISSIONS_SUCCESS = "PERMISSIONS_SUCCESS";
export const PERMISSIONS_FAILED = "PERMISSIONS_FAILED";